// extracted by mini-css-extract-plugin
export default {"editSingleIdentityAttributeContainer":"EditSingleIdentityAttribute_editSingleIdentityAttributeContainer__bwDcl"};